import { get, post, put, deleteRequest } from 'helpers/api';
import { toggleAssignee } from '../planner_filters/actions';
import { addAttachment } from '../deal/actions';

export function loadTasks() {
  return async (dispatch, getState) => {
    const state = getState();
    if (state.features.restrictedApex) {
      dispatch(setTasks([]));
    } else {
      const tasks = await get(state.deal.tasksPath);
      dispatch(setTasks(tasks));
    }
  };
}

export const SET_TASKS = 'SET_TASKS';
export function setTasks(tasks) {
  return { type: SET_TASKS, tasks };
}

export const ADD_TASK = 'ADD_TASK';
export function createTask(task) {
  return async (dispatch, getState) => {
    const newTask = await post(getState().deal.tasksPath, task);
    dispatch({ type: ADD_TASK, task: newTask });
    dispatch(togglePlannerAssignee(Number(task.assignee_id)));
  };
}

export const DELETE_TASK = 'DELETE_TASK';
export function deleteTask(task) {
  return async (dispatch) => {
    const deletedTask = await deleteRequest(task.path);
    dispatch({ type: DELETE_TASK, task: deletedTask });
  };
}

export const UPDATE_TASK = 'UPDATE_TASK';
export function updateTask(task) {
  return async (dispatch) => {
    const updatedTask = await put(task.path, task);
    dispatch({ type: UPDATE_TASK, task: updatedTask });
    dispatch(togglePlannerAssignee(Number(task.assignee_id)));
  };
}

function togglePlannerAssignee(assigneeId) {
  return (dispatch, getState) => {
    if (assigneeId && !getState().plannerFilters.selectedAssigneeIds.includes(assigneeId)) {
      dispatch(toggleAssignee(assigneeId));
    }
  };
}

export const ADD_TASK_ATTACHMENT = 'ADD_TASK_ATTACHMENT';
export function addTaskAttachment(task, attachment) {
  return async (dispatch, getState) => {
    dispatch(addAttachment(attachment));
    const stateTask = getState().tasks.find(({ id }) => id === task.id);
    if (stateTask.attachments.length === 0 && stateTask.attachmentExceptionReason) {
      const updatedTask = { ...task, attachmentException: 'none', attachmentExceptionReason: null };
      dispatch(updateTask(updatedTask));
    } else {
      dispatch({ type: ADD_TASK_ATTACHMENT, task, attachment });
    }
  };
}

export const DELETE_TASK_ATTACHMENT = 'DELETE_TASK_ATTACHMENT';
export function deleteTaskAttachment(task, attachment) {
  return {
    type: DELETE_TASK_ATTACHMENT,
    task,
    attachment
  };
}
